﻿{
  "version": 1,
  "gameId": "quiz",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "hintCoins": 10 },
  "cosmetics": {},
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "quiz.rules.navigationLabel",
    "kickerKey": "quiz.rules.kicker",
    "titleKey": "quiz.rules.title",
    "summaryKey": "quiz.rules.summary",
    "sections": [
      { "id": "teams", "key": "quiz.rules.teams" },
      { "id": "answer", "key": "quiz.rules.answer" },
      { "id": "reveal", "key": "quiz.rules.reveal" },
      { "id": "scoring", "key": "quiz.rules.scoring" },
      { "id": "rounds", "key": "quiz.rules.rounds" },
      { "id": "hints", "key": "quiz.rules.hints" },
      { "id": "finish", "key": "quiz.rules.finish" }
    ],
    "settingsAccess": false
  }
}
